import CmsPage from "./CmsPage";

const FiestasMajor = () => {
  return <CmsPage slug="fiestas-major" titleFallback="Fiestas Major" />;
};

export default FiestasMajor;
